import { loadStripe as loadStripeCore, Stripe } from '@stripe/stripe-js';
import { doFetch } from '@/util/fetch';
import { apiServer } from '@/util/apiServer';

// Fallback publishable key (kept for local/dev fallback only)
// const FALLBACK_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ;
const FALLBACK_PUBLISHABLE_KEY = '';

let cachedStripePromise: Promise<Stripe | null> | null = null;

/**
 * stripePromise: Promise that resolves to a Stripe instance loaded with the
 * publishable key fetched at runtime from /api/config/env (env.stripe.publishableKey).
 * The result is cached so loadStripe is only called once.
 */
export const stripePromise: Promise<Stripe | null> = (async () => {
	if (cachedStripePromise) return cachedStripePromise;

	cachedStripePromise = (async () => {
		try {
			const url = `${apiServer ?? ''}/api/config/env`;
			const res = await doFetch(url);
			if (res.ok) {
				const env = await res.json();
				const key = env?.stripe?.publishableKey ?? FALLBACK_PUBLISHABLE_KEY;
				try {
					const k = key || '';
					const masked = k.length > 8 ? `${k.substring(0,4)}...${k.substring(k.length-4)}` : k;
				} catch (e) {
					// ignore logging errors
				}
				return loadStripeCore(key);
			}
			console.warn('Failed to fetch env for Stripe key, status=', res.status);
		} catch (err) {
			console.warn('Error fetching Stripe key:', err);
		}

		// Fallback to bundled key
		// eslint-disable-next-line no-console
		console.info('[stripe] Falling back to bundled publishable key');
		return loadStripeCore(FALLBACK_PUBLISHABLE_KEY);
	})();

	return cachedStripePromise;
})();

export { FALLBACK_PUBLISHABLE_KEY };
